import React, { useEffect, useRef } from "react";
import AuctionIntroTour from "./AuctionIntroTour";
import { useState } from "react";
import { useLocation } from "react-router";
import PATH from "../../../config/PATH";
import {
  KEY_LOCAL_TYPE_USER,
  urlPageBid,
  currentDate,
  TYPE_USER,
  KEY_LOCAL_TOUR_COMPLETE,
  IS_UPDATE_VERSION_3_PROJECT,
} from "../../../helper/const";
import { useDispatch, useSelector } from "react-redux";
import { setReduxDataTypeIntroTour } from "../../../Redux/futures/home/actions";
import AuctionIntroTour2 from "./AutionIntroTour2";
import { curStateAccount, curStateHome } from "../../../Redux/selector";
import { useTranslation } from "react-i18next";
import iconBtnAction from "../../../assets/web-v3-images/btn-login.png";

const totalStep = IS_UPDATE_VERSION_3_PROJECT ? 13 : 8;
export default function IntroTourHome() {
  const [isSkip, setIsSkip] = useState(false);
  const [isTourComplete, setIsTourComplete] = useState(false);
  const [currentProduct, setCurrentProduct] = useState([]);
  const [bidTotal, setBidTotal] = useState(0);

  const { typeIntroTour } = useSelector((state) => state.reducerHome);
  const selectorAccount = useSelector(curStateAccount);
  const selectorHome = useSelector(curStateHome);

  const auctionIntroTourRef = useRef(null);
  const handleNextTour = () => {
    auctionIntroTourRef.current?.next();
  };

  const location = useLocation();

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const thisWeekPrizeText = t("user_guide.this_week_prize");
  const youHaveTurnsNowText = t("user_guide.you_have_turns_now")
    .replace("[number_of_turn]", bidTotal.toString())
    .replace("[product_name]", currentProduct[0]?.product_name || "");

  // dùng chung cho: skip tour, đóng tab/route giữa chừng khi tour đang chạy
  const resetIntroTourState = () => {
    dispatch(setReduxDataTypeIntroTour({ typeActive: 0, step: -1 }));
    localStorage.removeItem(KEY_LOCAL_TYPE_USER);
    localStorage.setItem(KEY_LOCAL_TOUR_COMPLETE, "true");
  };

  useEffect(() => {
    const tourComplete = localStorage.getItem(KEY_LOCAL_TOUR_COMPLETE);
    const typeUser = localStorage.getItem(KEY_LOCAL_TYPE_USER);

    // if user not login, do nothing
    if (!selectorAccount.userInfo) {
      return;
    }

    if (!(tourComplete === "true" || !typeUser)) {
      setIsTourComplete(false);
    }
  }, [selectorAccount.userInfo]);

  useEffect(() => {
    if (isTourComplete) {
      setIsSkip(true);
    }
  }, [isTourComplete]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (!selectorAccount.userInfo) {
        return;
      }

      if (typeIntroTour?.step >= 0 && typeIntroTour?.typeActive) {
        if (+typeIntroTour?.typeActive === TYPE_USER.newDeeplink) {
          if (window.location.pathname === PATH.PACKAGE_DAILY) {
            resetIntroTourState();
          }
        } else {
          resetIntroTourState();
        }
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [typeIntroTour]);

  useEffect(() => {
    if (selectorAccount.remainTurn) {
      const bidTotal = selectorAccount.remainTurn?.reduce((acc, pack) => {
        return acc + pack?.turn;
      }, 0);
      setBidTotal(bidTotal);
    }
  }, [selectorAccount.remainTurn]);

  useEffect(() => {
    if (selectorHome?.bidProduct?.length > 0) {
      let currentProduct = selectorHome.bidProduct.filter(
        (product) => new Date(product?.start_time).getTime() < currentDate,
      );
      setCurrentProduct(currentProduct);
    } else {
      setCurrentProduct([]);
    }
  }, [selectorHome.bidProduct]);

  useEffect(() => {
    setIsSkip(false);
  }, [typeIntroTour.typeActive, typeIntroTour.step]);

  // next hướng dẫn bước 2 sang trang bid
  const handleTourNextStepNavigateToBid = (typeActive = 2, step = 3) => {
    dispatch(
      setReduxDataTypeIntroTour({
        typeActive: +typeIntroTour?.typeActive || typeActive,
        step: step,
        page: `${PATH.BID}/${urlPageBid.running}`,
      }),
    );
  };

  // next hướng dẫn sang bước 2 trong trang home (case 4 và 5)
  const handleTourNextStepWithinHomePage = (typeActive = 4, step = 2) => {
    dispatch(
      setReduxDataTypeIntroTour({
        typeActive: +typeIntroTour?.typeActive || typeActive,
        step: step,
      }),
    );
  };

  // skip hướng dẫn
  const handleSkip = () => {
    resetIntroTourState();
    setIsSkip(true);
  };

  // mỗi bước tour đều dùng chung layout TourGuideContainer + handleSkip,
  // helper này chỉ còn phải khai báo phần khác nhau giữa các bước.
  const buildTourStep = (target, contentProps) => ({
    target,
    disableBeacon: true,
    content: <TourGuideContainer {...contentProps} handleSkip={handleSkip} />,
  });

  const dataTourVersion3 = [
    buildTourStep(".intro-tour-home__step-2", {
      handleNext: handleNextTour,
      guideText: t("user_guide.each_guess_costs"),
      title: t("user_guide.available_turns"),
      currentStep: 2,
    }),
    buildTourStep(".intro-tour-home__step-3", {
      handleNext: handleNextTour,
      guideText: t("user_guide.learn_how_to_play"),
      title: t("rule_page.rule"),
      currentStep: 3,
    }),
    buildTourStep(".intro-tour-home__step-4", {
      handleNext: handleNextTour,
      guideText: t("user_guide.change_your_password"),
      title: t("user_guide.setting"),
      currentStep: 4,
    }),
    buildTourStep(".intro-tour-home__step-5", {
      handleNext: handleNextTour,
      title: t("home.header.notifications"),
      guideText: t("user_guide.stay_updated_with_the_latest_news_and_rewards"),
      currentStep: 5,
    }),
    buildTourStep(".bit-container", {
      handleNext: handleNextTour,
      title: t("user_guide.guess_a_number"),
      guideText: t("user_guide.enter_your_lucky_price_and_tap"),
      currentStep: IS_UPDATE_VERSION_3_PROJECT ? 6 : 5,
    }),
    buildTourStep(".intro-tour-home__step-7", {
      handleNext: handleNextTour,
      title: t("home.cards.journal.title"),
      guideText: t(
        "user_guide.keep_your_streak_alive_and_claim_free_daily_rewards",
      ),
      currentStep: 7,
    }),
    buildTourStep(".intro-tour-home__step-8", {
      handleNext: handleNextTour,
      title: t("home.cards.vault.title"),
      guideText: t(
        "user_guide.collect_puzzle_pieces_and_open_the_vault_for_bigger_rewards",
      ),
      currentStep: 8,
    }),
    buildTourStep(".intro-tour-home__step-9", {
      handleNext: handleNextTour,
      title: t("user_guide.daily_prize"),
      guideText: t("user_guide.guess_a_lucky_price_each_day_to"),
      currentStep: 9,
    }),
    buildTourStep(".intro-tour-home__step-10", {
      handleNext: handleNextTour,
      title: t("home.cards.puzzle.title"),
      guideText: t(
        "user_guide.complete_puzzle_to_earn_coins_and_unlock_prizes",
      ),
      currentStep: IS_UPDATE_VERSION_3_PROJECT ? 10 : 6,
    }),
    buildTourStep(".intro-tour-home__step-11", {
      handleNext: handleNextTour,
      title: t("user_guide.loyalty_points_wallet"),
      guideText: t("user_guide.collect_loyalty_points_to_unlock_rewards"),
      currentStep: 11,
    }),
    buildTourStep(".intro-tour-home__step-12", {
      handleNext: handleNextTour,
      title: t("home.hero.history"),
      guideText: t("user_guide.check_previous_winners_and_results"),
      currentStep: IS_UPDATE_VERSION_3_PROJECT ? 12 : 7,
    }),
    buildTourStep(".intro-tour-home__step-13", {
      handleNext: handleSkip,
      nextLabel: t("user_guide.go_it"),
      title: t("shwe_vault.prizePool"),
      guideText: t("user_guide.view_all_prizes_of_this_month"),
      currentStep: IS_UPDATE_VERSION_3_PROJECT ? 13 : 8,
    }),
  ];

  const dataTourVersion2 = [
    buildTourStep(".intro-tour-home__step-2", {
      handleNext: handleNextTour,
      title: t("user_guide.available_turns"),
      guideText: t("user_guide.each_guess_costs"),
      currentStep: 2,
    }),
    buildTourStep(".intro-tour-home__step-3", {
      handleNext: handleNextTour,
      title: t("rule_page.rule"),
      guideText: t("user_guide.learn_how_to_play"),
      currentStep: 3,
    }),
    buildTourStep(".intro-tour-home__step-4", {
      handleNext: handleNextTour,
      title: t("user_guide.setting"),
      guideText: t("user_guide.change_your_password"),
      currentStep: 4,
    }),
    buildTourStep(".bit-container", {
      handleNext: handleNextTour,
      title: t("user_guide.guess_a_number"),
      guideText: t("user_guide.enter_your_lucky_price_and_tap"),
      currentStep: IS_UPDATE_VERSION_3_PROJECT ? 6 : 5,
    }),
    buildTourStep(".intro-tour-home__step-10", {
      handleNext: handleNextTour,
      title: t("home.cards.puzzle.title"),
      guideText: t(
        "user_guide.complete_puzzle_to_earn_coins_and_unlock_prizes",
      ),
      currentStep: IS_UPDATE_VERSION_3_PROJECT ? 10 : 6,
    }),
    buildTourStep(".intro-tour-home__step-12", {
      handleNext: handleNextTour,
      title: t("home.hero.history"),
      guideText: t("user_guide.check_previous_winners_and_results"),
      currentStep: IS_UPDATE_VERSION_3_PROJECT ? 12 : 7,
    }),
    buildTourStep(".intro-tour-home__step-13", {
      handleNext: handleSkip,
      nextLabel: t("user_guide.go_it"),
      title: t("shwe_vault.prizePool"),
      guideText: t("user_guide.view_all_prizes_of_this_month"),
      currentStep: IS_UPDATE_VERSION_3_PROJECT ? 13 : 8,
    }),
  ];

  // define data tour object
  let dataTour = [];

  if (typeIntroTour.step === 1) {
    dataTour = [
      buildTourStep(".intro-tour-home", {
        handleNext: handleTourNextStepNavigateToBid,
        guideText: thisWeekPrizeText,
      }),
    ];
  }

  // case 1
  if (
    typeIntroTour.typeActive === TYPE_USER.newNoPackage &&
    typeIntroTour.step === 1
  ) {
    dataTour = [
      buildTourStep(".intro-tour-home", {
        handleNext: handleNextTour,
        guideText: thisWeekPrizeText,
      }),
    ];
    if (IS_UPDATE_VERSION_3_PROJECT) {
      dataTour = [...dataTour, ...dataTourVersion3];
    } else {
      dataTour = [...dataTour, ...dataTourVersion2];
    }
  }

  if (
    typeIntroTour.typeActive === TYPE_USER.newDeeplink &&
    typeIntroTour.step === 0 &&
    location.pathname === PATH.PACKAGE_DAILY
  ) {
    dataTour = [
      buildTourStep(".box-item-package", {
        handleNext: () => setIsSkip(true),
      }),
    ];
  }

  if (
    typeIntroTour.typeActive === TYPE_USER.newPackage &&
    typeIntroTour.step === 1
  ) {
    dataTour = [
      buildTourStep(".intro-tour-home", {
        handleNext: handleNextTour,
      }),
    ];
    if (IS_UPDATE_VERSION_3_PROJECT) {
      dataTour = [...dataTour, ...dataTourVersion3];
    } else {
      dataTour = [...dataTour, ...dataTourVersion2];
    }
  }

  // case 4 => hightlight box số lượng bid hiện có
  if (
    typeIntroTour.typeActive === TYPE_USER.firstLoginAfterRegistered7Days &&
    typeIntroTour.step === 1
  ) {
    dataTour = [
      buildTourStep(".box-logo-info-number-bid", {
        handleNext: () =>
          handleTourNextStepWithinHomePage(
            TYPE_USER.firstLoginAfterRegistered7Days,
            2,
          ),
        guideText: youHaveTurnsNowText,
      }),
    ];
  }

  // case 4 bước 2 => hightlight sản phẩm hiện tại
  if (
    typeIntroTour.typeActive === TYPE_USER.firstLoginAfterRegistered7Days &&
    typeIntroTour.step === 2
  ) {
    dataTour = [
      buildTourStep(".intro-tour-home", {
        handleNext: () =>
          handleTourNextStepNavigateToBid(
            TYPE_USER.firstLoginAfterRegistered7Days,
            3,
          ),
        guideText: thisWeekPrizeText,
      }),
    ];
    return <AuctionIntroTour2 dataTour={dataTour} handleSkip={handleSkip} />;
  }

  // case 5 => hightlight box số lượng bid hiện có
  if (
    typeIntroTour.typeActive === TYPE_USER.firstLoginWithinRegistered2To6Days &&
    typeIntroTour.step === 1
  ) {
    dataTour = [
      buildTourStep(".box-logo-info-number-bid", {
        handleNext: () =>
          handleTourNextStepWithinHomePage(
            TYPE_USER.firstLoginWithinRegistered2To6Days,
            2,
          ),
        guideText: youHaveTurnsNowText,
      }),
    ];
  }

  // case 5 bước 2 => hightlight sản phẩm hiện tại
  if (
    typeIntroTour.typeActive === TYPE_USER.firstLoginWithinRegistered2To6Days &&
    typeIntroTour.step === 2
  ) {
    dataTour = [
      buildTourStep(".intro-tour-home", {
        handleNext: () =>
          handleTourNextStepNavigateToBid(
            TYPE_USER.firstLoginWithinRegistered2To6Days,
            3,
          ),
        guideText: thisWeekPrizeText,
      }),
    ];
    return <AuctionIntroTour2 dataTour={dataTour} handleSkip={handleSkip} />;
  }

  // case 6
  if (
    typeIntroTour.typeActive === TYPE_USER.loginButNeverBid &&
    typeIntroTour.step === 0
  ) {
    dataTour = [
      buildTourStep(".box-logo-info-number-bid", {
        handleNext: () =>
          handleTourNextStepWithinHomePage(TYPE_USER.loginButNeverBid, 1),
        guideText: youHaveTurnsNowText,
      }),
    ];
  }
  // case 6 bước 2 => hightlight sản phẩm hiện tại
  if (
    typeIntroTour.typeActive === TYPE_USER.loginButNeverBid &&
    typeIntroTour.step === 1
  ) {
    dataTour = [
      buildTourStep(".intro-tour-home", {
        handleNext: () =>
          handleTourNextStepNavigateToBid(TYPE_USER.loginButNeverBid, 2),
        guideText: youHaveTurnsNowText,
      }),
    ];
    return <AuctionIntroTour2 dataTour={dataTour} handleSkip={handleSkip}/>;
  }

  // skip hoặc đã hoàn thành hướng dẫn
  if (isSkip || +typeIntroTour.step === -1 || isTourComplete) {
    return <></>;
  }

  return <AuctionIntroTour dataTour={dataTour} ref={auctionIntroTourRef} handleSkip={handleSkip}/>;
}

function TourGuideContainer({
  handleSkip = () => {},
  handleNext = () => {},
  guideText = "",
  title = "Shwe Pick",
  currentStep = 1,
  nextLabel,
}) {
  const { t } = useTranslation();
  return (
    <div className="tour-main__content">
      <div className="tour-main__header">
        {currentStep}/{totalStep}
      </div>
      <div className="tour-main__header-title leading-[normal]">{title}</div>

      <div className="text-[#713B12] pb-1 leading-[normal]">
        {guideText !== "" ? guideText : t("user_guide.you_have_subs")}
      </div>
      <div className="tour-main__content_action">
        <button
          className="tour-main__content_action-btn-skip btn-click-active"
          onClick={handleSkip}
        >
          {t("user_guide.skip")}
        </button>
        <div className="relative btn-click-active" onClick={handleNext}>
          <img src={iconBtnAction} alt="" />
          <div className="guide-next">{nextLabel || t("user_guide.next")}</div>
        </div>
      </div>
    </div>
  );
}
